import StandardButton from '@components/ui/buttons/standard-button';
import { Box } from '@mui/material';
import verificationStyles from '@containers/form-verification/verification/styles';

export const ContinueBtn = (props: {
  onContinueBtnClick: (type: 'paid' | 'unpaid') => void,
  type: 'paid' | 'unpaid'
}) => {
  const { onContinueBtnClick, type } = props;
  return (
    <Box
      sx={{
        ...verificationStyles.bottomWrapper,
        position: 'sticky',
        bottom: 0
      }}>
      <StandardButton
        variant="contained"
        // color="primary"
        sx={{ width: '100%' }}
        onClick={() => onContinueBtnClick(type)}>
        Continue
      </StandardButton>
    </Box>
  );
};
